import { FC } from 'react';
import { z } from 'zod';
import React from "react";

const googleAnalyticsDataSchema = z.object({
  campaign: z.string(),
  medium: z.string(),
  content: z.string(),
  source: z.string(),
  accountId: z.string(),
});
type GoogleData = z.infer<typeof googleAnalyticsDataSchema>;

interface Props {
  linkData: GoogleData;
}

const SideNote: FC<Props> = ({ linkData }) => {
  return (
    <div className='p-4'>
      <h3 className=" text-base font-medium leading-5 text-[#495057] dark:text-white">
        Integrate Google Analytics URLs
      </h3>
      <div className="md:px-6 px-3 mt-4 py-4 rounded bg-[#ECF8F6] dark:bg-transparent border dark:border-[#fff]  ">
        <p className="text-sm leading-5 text-[#495057] dark:text-[#CED4DA]   mb-2">
          Google Analytics Integration automatically modifies all links in your
          HTML email with campaign parameters.
          <span className="font-semibold">
            Your website must have Google Analytics Integrated.
          </span>
        </p>
        <p className="text-sm font-medium leading-4 text-[#495057] dark:text-[#CED4DA]">
          Sample Link URL:
        </p>
        <p className="text-sm leading-5 text-[#495057] dark:text-[#CED4DA]  dark:text-white dark:text-white break-all mt-2">
          {`http://example.com/?utm_campaign=${linkData.source}workflow_name=${linkData.campaign}&utm_content=${linkData.content}subject&utm_medium=${linkData.medium}&utm_source=`}
        </p>
      </div>
    </div>
  );
};
export default SideNote;
